/**
 * O teto de leituras por IA, dito de um jeito que não trava a pessoa.
 *
 * ── O que estava errado ───────────────────────────────────────────────────
 *
 * O servidor responde 429 com "Muitas leituras por IA seguidas. Tente de novo
 * em 50 min." A tela mostrava isso e parava ali.
 *
 * A frase é verdadeira e é um beco sem saída: ela descreve a limitação do
 * sistema e não diz nada sobre o que a pessoa pode fazer — e o que ela pode
 * fazer é **tudo**, porque o formulário nunca dependeu de IA. A frase que
 * entendia ainda era o único caminho aos olhos dela.
 *
 * O pedido dela, exato: "em vez de mostrar 'muitas leituras por IA seguidas,
 * tentar novamente em 50 min', só diz que as chamadas via IA excederam mas que
 * ele pode continuar preenchendo manual, e abre o form".
 *
 * ── Por que o tempo saiu da mensagem ──────────────────────────────────────
 *
 * "Volte em 50 minutos" só é útil para quem não tem alternativa. Com o
 * formulário aberto na frente, o tempo vira ruído: informa sobre a coisa que
 * ela deixou de precisar.
 *
 * Onde NÃO existe formulário — Metas, onde o campo único é o único caminho de
 * criação —, a mensagem do servidor continua valendo inteira, com o tempo.
 * Ali ele é a única coisa acionável que existe.
 */

/**
 * A falha é o teto de IA?
 *
 * `429` e não o texto da mensagem: casar contra a frase amarraria esta decisão
 * à redação do servidor, que muda. E nos pontos onde isto é chamado, 429 só
 * pode vir de `limitar('ia')` — as rotas de parse não têm outro teto.
 *
 * O 503 de `limitar` fica de FORA de propósito: ele significa "não consegui
 * conferir o limite", que é falha de infraestrutura e não teto atingido.
 * Tratar os dois igual diria "você usou demais" para quem não usou nada.
 */
export const ehTetoDeIa = (erro: unknown): boolean =>
  (erro as { response?: { status?: number } })?.response?.status === 429;

/** Quando há formulário para abrir — o caso comum. */
export const AVISO_TETO_DE_IA =
  'Cheguei ao limite de leituras por IA por enquanto. Abri o formulário: '
  + 'preencher à mão funciona igual.';
